import { Skeleton, Stack } from "@mui/material";

function Loading1() {
    return (
        <Stack spacing={1}>
            <Skeleton variant="rectangular" width={"50%"} height={40} />
            <Skeleton variant="rectangular" width={"25%"} height={20} />
            <Skeleton variant="rectangular" width={"100%"} height={40} />
            <Skeleton variant="rectangular" width={"100%"} height={40} />
            <Skeleton variant="rectangular" width={"100%"} height={40} />
            <Skeleton variant="rectangular" width={"100%"} height={40} />
            <Skeleton variant="rectangular" width={"100%"} height={40} />
        </Stack>
    );
}

export default Loading1;
